var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4H9.71429V6.28571H6.28571V9.71429H4V4ZM14.2857 4H20V9.71429H17.7143V6.28571H14.2857V4ZM17.7143 14.2857H20V20H14.2857V17.7143H17.7143V14.2857ZM9.71429 17.7143V20H4V14.2857H6.28571V17.7143H9.71429Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreen);
export default __webpack_public_path__ + "static/media/full-screen.94d8ae8a0e8b2669c81c1d72a248ad85.svg";
export { ForwardRef as ReactComponent };